import { BACKGROUND_TASK_KIND, BACKGROUND_TASK_SLOT_KEY, } from './background-task';
/** One notification type pair for every background task (spec U-8). */
export const TASK_NOTIFICATION_TYPE = { COMPLETE: 'task:complete', FAILED: 'task:failed' };
const KINDS = new Set(Object.values(BACKGROUND_TASK_KIND));
const ENTITY_TYPES = new Set(['attachment', 'spreadsheet']);
export function isTaskNotificationData(raw) {
    if (!raw || typeof raw !== 'object')
        return false;
    const d = raw;
    return (typeof d.entityId === 'string' &&
        typeof d.entityType === 'string' &&
        ENTITY_TYPES.has(d.entityType) &&
        typeof d.kind === 'string' &&
        KINDS.has(d.kind) &&
        typeof d.slotKey === 'string' &&
        BACKGROUND_TASK_SLOT_KEY.test(d.slotKey) &&
        (d.slotKey === d.kind || d.slotKey.startsWith(`${d.kind}:`)) &&
        typeof d.workspaceId === 'string');
}
//# sourceMappingURL=task-notification.js.map